module.exports = __webpack_public_path__ + "static/media/audio.6928f4c4.png";